import React from 'react';
import { founderInfo } from '../data/mock';
import { Sparkles } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-rose-50 to-transparent" />
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-amber-50 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Visual */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              {/* Background shapes */}
              <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 w-full h-full bg-gradient-to-br from-rose-200 to-orange-200 rounded-3xl" />
              <div className="absolute -bottom-6 -right-6 md:-bottom-8 md:-right-8 w-full h-full bg-gradient-to-br from-amber-200 to-yellow-200 rounded-3xl" />
              
              {/* Main card */}
              <div className="relative bg-white rounded-3xl p-8 md:p-10 shadow-2xl">
                <div className="text-center">
                  {/* Avatar placeholder */}
                  <div className="w-24 h-24 md:w-32 md:h-32 mx-auto mb-6 rounded-full bg-gradient-to-br from-rose-500 to-orange-500 flex items-center justify-center">
                    <Sparkles className="w-10 h-10 md:w-12 md:h-12 text-white" />
                  </div>
                  
                  <h3 className="text-xl md:text-2xl font-black text-slate-900 mb-2">
                    {founderInfo.name}
                  </h3>
                  <p className="text-rose-500 font-semibold mb-6">
                    {founderInfo.tagline}
                  </p>

                  {/* Values */}
                  <div className="flex flex-wrap justify-center gap-2">
                    {founderInfo.values.map((value, index) => (
                      <span
                        key={index}
                        className="px-3 py-1.5 md:px-4 md:py-2 bg-slate-100 rounded-full text-xs md:text-sm font-medium text-slate-700"
                      >
                        {value}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="order-1 lg:order-2">
            <span className="inline-block text-sm font-bold text-rose-500 uppercase tracking-wider mb-4 px-4 py-2 bg-rose-50 rounded-full">
              Who We Are
            </span>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-6 leading-tight">
              <span className="bg-gradient-to-r from-rose-500 to-orange-500 bg-clip-text text-transparent">{founderInfo.experience}</span>
              {' '}of building growth systems.
            </h2>

            <p className="text-lg md:text-xl text-slate-600 mb-8 leading-relaxed">
              {founderInfo.description}
            </p>

            <div className="space-y-3 md:space-y-4">
              <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
                <span className="text-2xl md:text-3xl">🎯</span>
                <div>
                  <div className="font-bold text-slate-900">No outsourcing</div>
                  <div className="text-slate-600 text-sm">Direct access to senior expertise</div>
                </div>
              </div>
              <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
                <span className="text-2xl md:text-3xl">📊</span>
                <div>
                  <div className="font-bold text-slate-900">No guesswork</div>
                  <div className="text-slate-600 text-sm">Every decision backed by data</div>
                </div>
              </div>
              <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
                <span className="text-2xl md:text-3xl">⚡</span>
                <div>
                  <div className="font-bold text-slate-900">No fluff</div>
                  <div className="text-slate-600 text-sm">Just systems that actually work</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
